import { Component, Inject, OnInit, Optional } from '@angular/core';
import { FormBuilder, Validators } from '@angular/forms';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { ToastrService } from 'ngx-toastr';
import { DisposizioneCompagnia } from 'src/app/models/disposizione-compagnia';
import { BaseEditForm } from 'src/app/shared/baseEditForm';

@Component({
  selector: 'edit-disposizione-compagnia',
  templateUrl: './edit.component.html',
  styleUrls: ['./edit.component.scss']
})
export class EditDisposizioneCompagniaComponent extends BaseEditForm implements OnInit {

  files: File[] = [];
  isNew = false;

  constructor(
    private fb: FormBuilder,
    private toast: ToastrService,
    public dialogRef: MatDialogRef<EditDisposizioneCompagniaComponent>,
    @Optional() @Inject(MAT_DIALOG_DATA) public data: DisposizioneCompagnia,
  ) {
    super();
  }

  ngOnInit() {
    this.isNew = !this.data?.id;
    this.form = this.fb.group({
      gruppo: [this.data?.gruppo, Validators.required],
      titolo: [this.data?.titolo, Validators.required],
      contenuto: [this.data?.contenuto],
    });
  }

  onFilesSelected(event: Event) {
    const input = event.target as HTMLInputElement;
    if (input?.files) {
      for (let i = 0; i < input.files.length; i++) {
        this.files.push(input.files[i]);
      }
      input.value = '';
    }
  }

  removeFile(index: number) {
    this.files.splice(index, 1);
  }

  async handleSuccessfulSubmit(): Promise<any> {
    return { ...this.form.value, _files: this.files };
  }
}
